import React, {useState, useContext} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Copyright from '../../components/Common/Copyright';
import {useNavigate} from 'react-router-dom';
import schoolsArray from '../../assets/schools.json';
import {Context as AuthContext} from '../../contexts/AuthContext';
import logoImage from '../../assets/images/logoBlack.png';

const theme = createTheme();

const SignUp = ({showSuccess}) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loading, setLoading] = useState();

  const {
    state: {error},
    signup,
  } = useContext(AuthContext);
  console.log('ERROR', error);

  const processSignup = async () => {
    setLoading(true);

    const success = await signup(email, password, {
      firstName,
      lastName,
    });

    if (success) {
      showSuccess('Successfully signed up');
      navigate('/dashboard');
    }
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <img
          alt="Finsiteful"
          className="logo-image"
          style={{width: '210px', height: '150px'}}
          src={logoImage}
        />
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <Box noValidate sx={{mt: 3}}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                value={firstName}
                onChange={evt => {
                  setFirstName(evt.target.value);
                }}
                variant="outlined"
                autoComplete="given-name"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={lastName}
                onChange={evt => {
                  setLastName(evt.target.value);
                }}
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="family-name"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={email}
                onChange={evt => {
                  setEmail(evt.target.value);
                }}
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={password}
                onChange={evt => {
                  setPassword(evt.target.value);
                }}
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="new-password"
              />
            </Grid>
            {error && <Typography>{error}</Typography>}
          </Grid>
          <Button
            onClick={processSignup}
            type="submit"
            fullWidth
            variant="contained"
            sx={{mt: 3, mb: 2}}>
            Sign Up
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link href="/login" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{mt: 5}} />
    </Container>
  );
};

export default SignUp;

// import React, {useState, useContext, useEffect} from 'react';
// import TextField from '@mui/material/TextField';
// import Box from '@mui/material/Box';
// import Grid from '@mui/material/Grid';
// import Container from '@mui/material/Container';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import InputLabel from '@mui/material/InputLabel';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import {getAuth, createUserWithEmailAndPassword} from 'firebase/auth';
// import {db} from '../../api/firebase';
// import {collection, setDoc, getDocs, doc} from 'firebase/firestore';
// import style from '../../styles.css';
// import {createStyles} from '@mui/styles';
// import Typography from '@mui/material/Typography';
// import AuthLeft from '../../components/Auth/AuthLeft';
// import AuthFormFooter from '../../components/AuthFormFooter/AuthFormFooter';
// import CustomForm from '../../components/Forms/CustomForm';
// import {useNavigate} from 'react-router-dom';
// import {Context as AuthContext} from '../../contexts/AuthContext';

// // TODO: delete?
// function Signup({showSuccess, showError}) {
//   const navigate = useNavigate();
//   const [username, setUsername] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loginCode, setLoginCode] = useState('');
//   const [school, setSchool] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [jobTitle, setJobTitle] = useState('');
//   const [schoolOptions, setSchoolOptions] = useState();
//   const [jobTitleOptions, setJobTitleOptions] = useState();
//   const [processingSignup, setProcessingSignup] = useState();

//   const {state, signup} = useContext(AuthContext);

//   const processSignup = async () => {
//     setProcessingSignup(true);

//     // CREATE SCHOOL CODE
//     const schoolNameWordArray = school.split(' ');
//     let schoolInitials = '';

//     schoolNameWordArray.map(word => {
//       return (schoolInitials += word[0]);
//     });

//     const randomNumbers = new Date().getTime().toString();

//     const code =
//       schoolInitials.toLowerCase().replace(/\W/g, '') +
//       '-' +
//       randomNumbers.substring(
//         randomNumbers.length - 5,
//         randomNumbers.length - 1,
//       );

//     const success = await signup(email, password, {
//       fullName: firstName + ' ' + lastName,
//       school,
//       code,
//     });

//     if (success) {
//       showSuccess('Successfully signed up');
//       setLoginCode(code);
//     }
//     setProcessingSignup(false);
//   };

//   const getJobTitleOptions = async () => {
//     const jobs = [];

//     const querySnapshot = await getDocs(collection(db, 'jobTitles'));
//     querySnapshot.forEach(doc => {
//       const data = doc.data();
//       jobs.push({
//         id: doc.id,
//         name: data.name,
//       });
//     });

//     setJobTitleOptions(jobs);
//   };

//   const getSchoolOptions = async () => {
//     const schools = [];

//     const querySnapshot = await getDocs(collection(db, 'schools'));
//     querySnapshot.forEach(doc => {
//       const data = doc.data();
//       schools.push({
//         id: doc.id,
//         name: data.name,
//       });
//     });

//     setSchoolOptions(schools);
//   };

//   React.useEffect(() => {
//     if (!jobTitleOptions) {
//       getJobTitleOptions();
//     }
//     if (!schoolOptions) {
//       getSchoolOptions();
//     }
//   }, []);

//   return (
//     <div className="auth-style">
//       <Container sx={{marginTop: '40px', marginBottom: '40px'}} maxWidth="xl">
//         <CustomForm submitHandler={processSignup}>
//           <Grid container spacing={2}>
//             <Grid item lg={6} xs={12}>
//               <AuthLeft
//                 heading="Welcome to Finsiteful"
//                 subheading="Get your students subscribed and unlock their potential for financial freedom."
//               />
//             </Grid>
//             <Grid item lg={6} xs={12}>
//               <Box
//                 className="custom-form auth-right-wrapper"
//                 component="form"
//                 sx={{
//                   '& > :not(style)': {
//                     width: '100%',
//                     backgroundColor: '#07162D',
//                     borderRadius: '24px',
//                   },
//                 }}
//                 noValidate
//                 autoComplete="off">
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Typography variant="h4" className="form-title">
//                       Sign up
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth>
//                       <TextField
//                         id="loginCode"
//                         label="Desired login code"
//                         value={loginCode}
//                         onChange={evt => setLoginCode(evt.target.value)}
//                         variant="outlined"
//                         placeholder="Desired login code"
//                       />
//                     </FormControl>
//                   </Grid>
//                   {/* <Grid item xs={12}>
//                       <FormControl fullWidth>
//                         <TextField
//                           id="username"
//                           label="Username"
//                           value={username}
//                           onChange={(evt) => setUsername(evt.target.value)}
//                           variant="outlined"
//                           placeholder="Username" />
//                       </FormControl>
//                     </Grid> */}
//                   {/* <Grid item xs={12}>
//                       <FormControl fullWidth>
//                         <TextField id="password" label="Password" value={password} onChange={(evt) => setPassword(evt.target.value)} variant="outlined" placeholder="Password" type="password" />
//                       </FormControl>
//                     </Grid> */}
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <TextField
//                         id="firstname"
//                         label="First name"
//                         value={firstName}
//                         onChange={evt => setFirstName(evt.target.value)}
//                         variant="outlined"
//                         placeholder="First name"
//                       />
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <FormControl fullWidth>
//                       <TextField
//                         id="lastname"
//                         label="Last name"
//                         value={lastName}
//                         onChange={evt => setLastName(evt.target.value)}
//                         variant="outlined"
//                         placeholder="Last name"
//                       />
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth>
//                       <InputLabel id="school">School</InputLabel>
//                       <Select
//                         labelId="school"
//                         id="school"
//                         value={school}
//                         label="School"
//                         onChange={evt => setSchool(evt.target.value)}>
//                         {schoolOptions &&
//                           schoolOptions.map(school => (
//                             <MenuItem key={school.id} value={school.id}>
//                               {school.name}
//                             </MenuItem>
//                           ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth>
//                       <InputLabel id="jobtitle">Job Title</InputLabel>
//                       <Select
//                         labelId="jobtitle"
//                         id="jobtitle"
//                         value={jobTitle}
//                         label="Job title"
//                         onChange={evt => setJobTitle(evt.target.value)}>
//                         {jobTitleOptions &&
//                           jobTitleOptions.map(jobTitle => (
//                             <MenuItem key={jobTitle.id} value={jobTitle.id}>
//                               {jobTitle.name}
//                             </MenuItem>
//                           ))}
//                       </Select>
//                     </FormControl>
//                     <FormGroup>
//                       <FormControlLabel
//                         className="white-label"
//                         style={{
//                           /*marginTop: '187px',*/ marginTop: '25px',
//                           fontSize: '16px',
//                         }}
//                         label={
//                           <span>
//                             I have read and accepted Finsiteful's{' '}
//                             <a href="">Privacy Policy</a> and{' '}
//                             <a href="">Terms of Service</a>
//                           </span>
//                         }
//                         control={
//                           <Checkbox
//                             className="terms-checkbox"
//                             checked={termsAccepted}
//                             onChange={evt =>
//                               setTermsAccepted(evt.target.checked)
//                             }
//                           />
//                         }
//                       />
//                     </FormGroup>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <AuthFormFooter
//                       processClick={processSignup}
//                       disabled={processingSignup}
//                       whiteText="Already have an account?"
//                       buttonText={processingSignup ? 'Loading...' : 'Sign up'}
//                       blueText="Log in"
//                       blueTextUrl="/login"
//                     />
//                     <div style={{marginTop: '187px'}}></div>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Grid>
//           </Grid>
//         </CustomForm>
//       </Container>
//     </div>
//   );
// }

// export default Signup;
